import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const renderCustomIconExpanderHeader = (icon: IconDefinition, iconColor: string, text: string) => {
    return (
        <>
            <FontAwesomeIcon
                icon={icon}
                className={'customIcon'}
                style={{ color: `${iconColor}` }}
            />
            <h3>{text}</h3>
        </>
    );
};

export const renderCustomCountExpanderHeader = (count: number, text: string) => {
    return (
        <>
            <h3>
                <span className={'customCount'}>({count})</span>
                {text}
            </h3>
        </>
    );
};
